import React, { useEffect, useMemo, useRef, useState, useContext } from "react";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { formatDate } from "../../../helpers/dates";
import { useAxiosSWR } from "root/axiosInstance";
import AppContext, { URL_TYPES } from "src/context";
import { LiaShareSolid } from "react-icons/lia";
import { MdZoomIn } from "react-icons/md";
import { MdOutlineZoomOut } from "react-icons/md";
import { IoMdHeart } from "react-icons/io";
import { ShimmerEffect } from "../../common/ShimmerEffect";
import { NewsNames, SocialLinksComponent, socialLinksV2 } from "./general";
import { HiMiniXMark } from "react-icons/hi2";
import { FaInfo } from "react-icons/fa";
import { NewsFAQs } from "./newsFAQs";
import { TableOfContents } from "./fantasyComponents/TableOfContents";
import { getAssetUrl, doScrollToTop, isLiveNewsTag } from "../../../helpers/general";
import { AnalyticsCategory, TrackGoogleAnalyticsEvent } from "../../../helpers/analytics";
import { doHardReloadArticle, getMobileDetect, headingTag, isShowRajaBetsAd, showGoogleAd, SlotProps } from "../../../constants";
import GoogleAdUnit, { pushGoogleAd } from "../../../../src/components/common/GoogleAdUnit";
// import OutbrainWidget from "../../common/OutbrainWidget";
import { useNewDetailToolbarShowHideOnScroll } from "../../../hooks/useShowHideOnScroll";
import CustomBlock from "./fantasyComponents/CustomBlock";
import { useLoadSocialMedia } from "../../../hooks/useLoadSocialMedia";
import RajaBetsAdContainer from "../../common/Rajabetads/RajaBetsAdContainer";
const SEOMeta = React.lazy(() => import("../Home/common/SEOMeta"));
const MoreStories = React.lazy(() => import("../../common/MoreStories"));
const NewsMatchInfo = React.lazy(() => import("./fantasyComponents/NewsMatchInfo"));
const FantasyCommon = React.lazy(() => import("../../common/FantasyCommon"));
const view = getAssetUrl("authorsInstanceViews.svg");
const RajabetDesktopad = "https://static.cricketgully.com/cg-spa-static-assets/Assets/raja/960x100.png";
const RajabetMobilead = "https://static.cricketgully.com/cg-spa-static-assets/Assets/raja/320x100__.png";

const LinksByType = {
  top_story: '/cricket-top-story',
  weekly_recap: '/cricket-news',
  news: '/cricket-news',
  fantasy: '/fantasy-cricket-tips'
};

const CustomBlockData = {
  heading: "Disclaimer",
  content: "This is a team that is created on the basis of the author's knowledge, analysis, and judgment. While selecting your team, do take note of the points mentioned and make your own decision.",
};

const redirectToLiveBlog = (newsData, navigate) => {
  if (!newsData) return null;
  const publishedAt = new Date(newsData.publishedAt);
  const targetDate = new Date('2025-03-01');
  if (publishedAt >= targetDate && newsData.isLive) {
    navigate(`/live-blogs/${newsData.slug}-${newsData.id}`);
  }
}

const NewsDetails = () => {
  const { id: slug } = useParams();
  const navigate = useNavigate();
  const [seoMeta, setSEOMeta] = useState(null);
  const [act, setAct] = useState(null)
  const [isLiked, setIsLiked] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [fontSize, setFontSize] = useState(document.body.clientWidth > 700 ? 18 : 14);
  const [isContentExpanded, setIsContentExpanded] = useState(false);
  const [likeCount, setLikeCount] = useState(0)
  const containerRef = useRef();
  const { pathname: pathName } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const current = containerRef.current;
  const memoizedValues = useMemo(() => {
    const parts = slug.split("-");
    const newsId = parts[parts.length - 1];
    return { newsId };
  }, [slug]);
  const { newsId } = memoizedValues;
  const {
    data: dataObj,
    isLoading,
    error: isError,
    mutate
  } = useAxiosSWR(`/v1/news/${newsId}`);

  const showParticularArticleAd = Number(newsId) === 3536;

  useEffect(() => {
    redirectToLiveBlog(dataObj, navigate);
  }, [dataObj]);

  const author = dataObj?.author;
  const isLiveArticle = isLiveNewsTag(dataObj?.info?.isLive)
  useEffect(() => {
    let timerId;
    if (isLiveArticle) {
      timerId = setInterval(() => {
        mutate();
      }, 30000);
    }

    return () => {
      clearInterval(timerId);
    }
  }, [isLiveArticle])
  useEffect(() => {
    if (dataObj) {
      /*
      try {
        (function (w, q) {
          console.log("Script called:", q);
          w[q] = w[q] || [];
          w[q].push(["_mgc.load"]);
        })(window, "_mgq");
      } catch (error) {
        console.log('Error occurred while fetching Ad by mgc')
      }
      */
    }
  }, [pathName, dataObj]);

  const appContext = useContext(AppContext);

  const newsTitle = dataObj?.title;
  useEffect(() => {
    const urlInfoObj = {
      type: URL_TYPES.NEWS_DETAILS,
      path: pathName,
      reqState: {
        data: {
          title: newsTitle,
        },
      }
    };
    appContext.updateUrlInfo(urlInfoObj);
  }, [pathName, newsTitle]);

  const isFantasyNews = dataObj?.type === 'fantasy';
  const customBlocks = dataObj?.info?.customBlocks;

  const {
    data: likeUnlikeData,
    isLoading: likeLoading,
    error: likeError
  } = useAxiosSWR(act ? `/v1/news/${newsId}/${act}` : null)
  useEffect(() => {
    if (likeUnlikeData) {
      setLikeCount(likeUnlikeData?.likes)
      setIsLiked(act === "like" ? true : false)
    }
  }, [likeUnlikeData])
  const dataObject = dataObj || {};
  let htmlContent = (dataObject?.content || '') + '';

  if (htmlContent?.includes('{{GOOGLE_AD_1}}')) {
    htmlContent = htmlContent.replace(
      /{{GOOGLE_AD_1}}/g,
      `<div class="flex justify-center my-2">
        <ins class="adsbygoogle"
        style="display:block; text-align:center;"
        data-ad-layout="in-article"
        data-ad-format="fluid"
        data-ad-client="ca-pub-3220816308063959"
        data-ad-slot="3389217727"></ins>
      </div>`
    )
  }

  useEffect(() => {
    if (htmlContent && htmlContent.includes("adsbygoogle")) {
      pushGoogleAd(" news details page");
    }
  }, [htmlContent])

  useEffect(() => {
    if (dataObject?.info) {
      setSEOMeta({
        title: dataObject?.info?.metaTitle || dataObject?.title,
        description: dataObject?.info?.metaDescription,
        image: dataObject?.image
      });
    }
    if (dataObject?.cnt_likes) {
      setLikeCount(dataObject?.cnt_likes)
      setIsLiked(dataObject?.is_liked)
    }
    if (dataObject?.info?.showReadMore) {
      setIsContentExpanded(true)
    }
  }, [dataObject]);
  useEffect(() => {
    if (current && dataObj) {
      try {
        const tableElements = current.getElementsByTagName("table");
        for (let i = 0; i < tableElements.length; i++) {
          const currentTable = tableElements[i];
          const wrapper = document.createElement("div");
          wrapper.className = "table-wrapper";
          wrapper.style.overflowX = "auto";
          wrapper.style.width = "100%";
          currentTable.parentElement.replaceChild(wrapper, currentTable);
          wrapper.appendChild(currentTable);
        }
        const headingElements = current.querySelectorAll("h1, h2, h3, h4, h5, h6");
        headingElements.forEach(heading => {
          const tagName = heading.tagName.toLowerCase();
          const adjustment = headingTag[tagName];
          heading.style.fontSize = `${fontSize + adjustment}px`;
        });
      } catch (error) {
      }
    }
  }, [current, dataObj, fontSize]);


  const newsType = dataObject?.type;
  useEffect(() => {
    setIsContentExpanded(false);
  }, [slug]);

  useLoadSocialMedia(dataObject);
  const topAdHeightPx = searchParams.get("topAdHeightPx");

  const md = getMobileDetect();
  const isMobile = Boolean(md.mobile());
  const isNotMobile = !isMobile;
  const dumbStyle = useMemo(() => {
    if (!isMobile || !topAdHeightPx) {
      return {};
    }

    if (isMobile && topAdHeightPx.includes("px")) {
      return {
        height: topAdHeightPx,
        minHeight: topAdHeightPx
      }
    }

  }, [searchParams, isMobile]);

  const newsDetailToolBarRef = useRef(null);
  const newsDetailLiveTagRef = useRef(null);
  useNewDetailToolbarShowHideOnScroll(newsDetailToolBarRef, newsDetailLiveTagRef);

  if (!isLoading && !dataObject && !isError) {
    return null;
  }
  if (isLoading) {
    return <div className="min-h-screen"></div>;
  }
  if (isError) {
    return (
      <div></div>
    )
  }

  const handleLike = () => {
    if (act === "like" || isLiked) {
      setAct("unlike");
    } else if (act === "unlike" || !isLiked) {
      setAct("like");
    }
    TrackGoogleAnalyticsEvent(AnalyticsCategory.ARTICLE, 'article_like', window.location.pathname)
  };

  const handleShareClick = (e) => {
    e.preventDefault();
    try {
      if (navigator.share) {
        navigator.share({
          title: dataObject?.title || "",
          text: dataObject?.title || "",
          url: window.location.href,
        });
        return;
      }
    } catch (error) {
      console.log('Sharing failed.. now sharing manually... , Error is ', error);
    }
    try {
      navigator.clipboard.writeText(window.location.href);
    } catch (error) {
    }
    setShowPopup(!showPopup);
    TrackGoogleAnalyticsEvent(AnalyticsCategory.ARTICLE, 'article_share', window.location.pathname)
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleZoomIn = () => {
    setFontSize((prevSize) => Math.min(prevSize + 1, 30));
  };

  const handleZoomOut = () => {
    setFontSize((prevSize) => Math.max(prevSize - 1, 12));
  };

  const isLiveClass = isLiveNewsTag(dataObj?.info?.isLive) ? "isLive" : "";

  return (
    <div>
      {showPopup && <div className="overlay z-40" onClick={handleClosePopup} />}
      <div>
        {showPopup && (
          <div className="modal-content fixed bg-white shadow-md md:py-4 md:px-[30px] p-4 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 rounded-2xl">
            <SocialLinksComponent
              socialLinks={socialLinksV2}
              className="container"
              type="share"
              textInputValue={window.location.href}
              closeIcon={<HiMiniXMark className="md:w-6 md:h-6 w-5 h-5 border border-[#E3E3E4] text-gray-400 rounded-full cursor-pointer" onClick={handleClosePopup} />} />
          </div>
        )}
        <div className="rounded-2xl md:border md:mt-4 md:bg-white md:mx-0 mx-[6px] mt-[6px]">
          <div className={`md:pt-10 article-font relative ${isContentExpanded ? 'overflow-hidden md:rounded-b-xl' : ""} `}
            style={{ maxHeight: isContentExpanded ? '1000px' : 'none' }}
          >
            {isMobile && (showGoogleAd || Boolean(showParticularArticleAd)) &&
              <div style={dumbStyle} className="px-1 ___overflow-hidden hideScrollbar __flex __items-center __justify-center">
                <GoogleAdUnit insCustomClass='mt-1 mb-1' slotProps={SlotProps.Mobile_Article_Page_Top_Fluid} />
              </div>
            }
            {dataObj !== undefined ? <>
              <div>
                {seoMeta && <React.Suspense><SEOMeta data={seoMeta} /></React.Suspense>}
                <div className="bg-white rounded-2xl md:rounded-none border md:border-none">
                  <div className="text-[#646464] md:text-sm text-[9px] inline-block px-4 md:px-10 md:pt-0 pt-4">
                    <Link to={"/"} className="text-[#3A32D1]"> Home </Link>
                    <span>{">"}</span>
                    <Link to={LinksByType[dataObj.type] || '/cricket-news'}>
                      <span className="ml-1 text-[#3A32D1]">{NewsNames[dataObj.type]}</span>
                    </Link>
                  </div>
                  <div className="px-4 md:px-10">
                    <h1
                      className={`${dataObject.title.split(" ").length >= 22 && isFantasyNews ? 'md:text-[24px]' : 'md:text-3xl'} font-semibold text-lg pt-2 pb-3 md:leading-[32px] leading-[27px]`}
                    >{dataObject.title}</h1>
                    <div data-testid="mobile_updated_at" className="flex md:hidden pt-2 pb-3">
                      {dataObj.updatedAt && <p className="lg:text-sm text-[#00000080] text-[10px] font-semibold">Updated - {formatDate(dataObj.updatedAt)}</p>}                    </div>
                    <span className="block border-b py-1"></span>
                    <p className="lg:text-xl md:text-lg py-5 text-sm font-[400]">{dataObject.excerpt}</p>
                    <div data-testid="all_device_container" className="flex items-center justify-between">
                      <div className="flex flex-wrap items-center gap-3">
                        <div data-testid="desktop_updated_published" className="hidden gap-3 md:flex">
                          {(dataObject.publishedAt || dataObject.createdAt) && <p className="lg:text-sm text-[#00000080] text-[10px] font-semibold">Published {formatDate(dataObject.publishedAt || dataObject.createdAt)}</p>}
                          {dataObj.updatedAt && <p className="lg:text-sm text-[#00000080] text-[10px] font-semibold"><span className="mr-3">|</span> Updated - {formatDate(dataObj.updatedAt)}</p>}
                        </div>

                        <p data-testid="mobile_published_at" className="flex md:hidden">
                          {(dataObject.publishedAt || dataObject.createdAt) && <span className="lg:text-sm text-[#00000080] text-[10px] font-semibold">{formatDate(dataObject.publishedAt || dataObject.createdAt)}</span>}
                        </p>

                        <p className="lg:text-sm text-[#6c6c6c96] text-[10px] font-semibold">
                          {author?.username ? <Link className="text-[#3A32D1]" to={`/authors/${author?.username}`}>By {dataObject.author.name}</Link> : `By ${author?.name || "CricketGully"}`}
                        </p>
                      </div>
                      <div className='flex items-center gap-2 text-center'>
                        <div className='w-max mx-auto'>
                          <img src={view} alt="" />
                        </div>
                        <div className='text-[10px] md:text-[12px] md:font-medium text-[#B2B3B5]'>
                          Views
                        </div>
                        <div className='text-[10px] md:text-[12px] md:font-medium text-[#6C6C6C] text-center'>
                          {dataObj?.cnt_views ? dataObj?.cnt_views?.toLocaleString("en-IN") : 0}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 px-4 md:px-10 relative">
                    <ShimmerEffect src={dataObject.image} alt={dataObj?.info?.imageAltText || dataObject.title} className="rounded-xl w-full md:h-[490px] h-[181px]" />
                    {showPopup ? null :
                      <div className="absolute bg-white z-10 md:bottom-6 bottom-3 rounded-full ml-[12px] group flex items-center">
                        {dataObject?.image_source ? (
                          <>
                            <FaInfo className="w-7 h-7 p-2" />
                            <span className="hidden group-hover:inline-block md:text-sm text-[10px] rounded pr-4">
                              {dataObject?.image_source}
                            </span>
                          </>
                        ) : null}
                      </div>
                    }
                  </div>
                  <div ref={newsDetailToolBarRef} className="sticky z-30 md:top-[60px] top-[48px] bg-white md:p-2 md:py-6 p-4 border-b md:px-10">
                    <div className="flex justify-between">
                      <div className="flex items-center">
                        <div className="bg-[#FFFFFF] md:p-3 p-2 rounded-full shadow-md md:w-12 md:h-12 w-8 h-8 cursor-pointer" onClick={handleLike}>
                          {
                            !likeLoading &&
                            <IoMdHeart
                              className={`md:h-6 h-4 md:w-6 w-4 ${isLiked ? 'text-[#D6313E]' : 'text-[#000000]'}`}
                            />
                          }
                        </div>
                        <div className="ml-2 md:text-[20px] text-xs md:pt-0 pt-1 md:leading-8">{likeCount}
                          <p className="lg:text-sm text-[#6c6c6c96] text-[8px] font-semibold">Liked this post</p>
                        </div>
                      </div>
                      <div
                        className="bg-[#FFFFFF] md:p-3 p-2 rounded-full shadow-md md:w-12 md:h-12 w-8 h-8 cursor-pointer"
                        onClick={handleShareClick}
                      >
                        <LiaShareSolid className="md:h-6 h-4 md:w-6 w-4" />
                      </div>
                      <div
                        className="bg-[#FFFFFF] md:p-3 p-2 rounded-full shadow-md md:w-12 md:h-12 w-8 h-8 cursor-pointer"
                        onClick={handleZoomIn}
                      >
                        <MdZoomIn className="md:h-6 h-4 md:w-6 w-4" />
                      </div>
                      <div
                        className="bg-[#FFFFFF] md:p-3 p-2 rounded-full shadow-md md:w-12 md:h-12 w-8 h-8 cursor-pointer"
                        onClick={handleZoomOut}
                      >
                        <MdOutlineZoomOut className="md:h-6 h-4 md:w-6 w-4" />
                      </div>
                    </div>
                  </div>
                  {isLiveNewsTag(dataObject?.isLive) ? <div ref={newsDetailLiveTagRef} className="sticky z-30 md:top-[160px] top-[117px] flex justify-center mt-3">
                    <div className="flex items-center gap-[6px] h-[26px] w-[60px] border-[2px] border-[#1CEC2A] bg-[#009E0A] rounded-[30px] blink-animation">
                      <span className="block bg-[#1CEC2A] h-[10px] w-[10px] rounded-full ms-1 opacity-animation"></span>
                      <span className="text-white text-[14px]">LIVE</span>
                    </div>
                  </div> : null}
                  {showGoogleAd || Boolean(showParticularArticleAd) ?
                    <>
                      {isMobile ?
                        <div className="flex justify-center overflow-x-hidden overflow-y-hidden"> {/* max-h-[260px] */}
                          <GoogleAdUnit insCustomClass='mt-2' slotProps={SlotProps.Mobile_News_Details_Below_Image} />
                        </div>
                        :
                        <div className="flex justify-center overflow-x-hidden">
                          <GoogleAdUnit insCustomClass='mt-2' slotProps={SlotProps.Desktop_News_Details_Below_Image} />
                        </div>
                      }
                    </> : null
                  }
                  {((isFantasyNews && dataObj?.match_id) || (Array.isArray(customBlocks) && customBlocks.length > 0)) &&
                    <TableOfContents newsObj={dataObj} />
                  }

                  {htmlContent && htmlContent.trim().length > 0 && <div className="md:px-10 md:pt-10 pb-0 px-4 py-6 relative">
                    <div
                      ref={containerRef}
                      className={`leading-[${fontSize + 4}] newsContentDiv font-[400] ${isLiveClass}`}
                      style={{ fontSize: `${fontSize}px` }}
                      dangerouslySetInnerHTML={{ __html: htmlContent }}
                    />
                  </div>}
                  {
                    !isFantasyNews &&
                    <div className="flex gap-2 md:pt-8 py-4 md:justify-start justify-center flex-wrap text-nowrap px-4 md:px-10">
                      {dataObject?.tags?.map((tag, index) => (
                        <Link key={index} to={`/tag/${encodeURIComponent(tag.keyword_slug)}`} onClick={doScrollToTop}>
                          <div color="indigo" className="text-[#3A32D1] bg-[#3A32D1] bg-opacity-10 font-semibold md:text-[18px] text-xs px-6 md:px-[24px] md:py-3 py-2 rounded-[50px]">
                            {tag.keyword}
                          </div>
                        </Link>
                      ))}
                      <div data-testid="mobile_site_thank" className="block md:hidden md:pt-0 md:bg-none w-full">
                        <div className='py-3'>
                          <div className="flex items-center min-w-[50px]">
                            <span className="custom-border-left mr-3 md:mr-6"></span>
                            <p className='text-sm text-[#787878]'>Thank You</p>
                            <span className="custom-border-right ml-3 md:ml-6"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <NewsFAQs content={dataObj?.info?.faqs} />
                </div>
                {isContentExpanded && (
                  <div className="absolute bottom-0 left-0 right-0 flex md:rounded-b-xl items-end justify-center w-full pb-4 h-[150px] bg-gradient-to-t from-white to-transparent">
                    <button
                      onClick={() => setIsContentExpanded(false)}
                      className="text-[#3A32D1] font-semibold text-xs bg-white rounded-full py-3 px-8 shadow-lg"
                    >
                      Read More
                    </button>
                  </div>
                )}
                {((isFantasyNews && dataObj?.match_id) || (Array.isArray(customBlocks) && customBlocks.length > 0)) &&
                  <div className="md:px-10">
                    <React.Suspense><NewsMatchInfo newsObj={dataObj} /></React.Suspense>
                  </div>
                }
              </div>
              {!isFantasyNews &&
                <>
                  <div data-testid="desktop_thank_you" className='hidden md:block px-10 pt-4'>
                    <div className="flex items-center min-w-[50px]">
                      <span className="custom-border-left mr-3 md:mr-6"></span>
                      <p className='text-md text-[#787878]'>Thank You</p>
                      <span className="custom-border-right ml-3 md:ml-6"></span>
                    </div>
                  </div>
                </>
              }
            </> :
              <div>
                <h3>No Data Found...</h3>
              </div>
            }
          </div>
        </div>
      </div>
      {isShowRajaBetsAd && isFantasyNews ? (
        <div className="mx-[6px] mx:mx-0">
          <RajaBetsAdContainer
            imageUrl={isMobile ? RajabetMobilead : RajabetDesktopad}
            adClass="w-full h-full mt-4"
          />
        </div>
      ) : null}
      {
        isFantasyNews && dataObj?.match_id &&
        <>
          <div className="mt-5 border bg-white rounded-2xl" data-testid="dump_king_container">
            <div className="article-font bg-[#E8F1FF] rounded-t-[14px] md:text-2xl text-base leading-6 p-4 font-bold">
              <div className="flex items-center gap-2 md:justify-start justify-center">
                <h2 className='text-base md:text-2xl'>Dream11 Team For This Match</h2>
              </div>
            </div>

            <div>
              <div className='md:px-[30px] md:py-8 py-4 mx-[6px] md:mx-0'>
                <React.Suspense><FantasyCommon matchId={dataObject?.match_id} readFullArticle={false} pageType={"fantasy-details"} /></React.Suspense>
                <div className="flex gap-2 md:pt-8 pt-4 md:justify-start justify-center flex-wrap text-nowrap">
                  {dataObject?.tags?.map((tag, index) => (
                    <Link key={index} to={`/tag/${encodeURIComponent(tag.keyword)}`} onClick={doScrollToTop}>
                      <div key={index} color="indigo" className="text-[#3A32D1] bg-[#3A32D1] bg-opacity-10 font-semibold md:text-[18px] text-xs px-6 md:px-[24px] md:py-3 py-2 rounded-[50px]">{tag.keyword}</div>
                    </Link>
                  ))}
                </div>
                <div className="article-font px-2 md:px-0">
                  <CustomBlock data={CustomBlockData} />
                </div>
                <div data-testid="fantasy_thank_you" className='p-4 pb-4'>
                  <div className="flex items-center min-w-[50px]">
                    <span className="custom-border-left mr-3 md:mr-6"></span>
                    <p className='text-sm md:text-md text-[#787878]'>Thank You</p>
                    <span className="custom-border-right ml-3 md:ml-6"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }

      {Boolean(md.mobile()) && (showGoogleAd || Boolean(showParticularArticleAd)) ? <div className="flex justify-center px-2 overflow-hidden">
        <GoogleAdUnit insCustomClass='mt-4' slotProps={SlotProps.News_Details_Page_Square} />
      </div> : null}

      {/* {showGoogleAd || Boolean(showParticularArticleAd) && <div className="my-1 flex justify-center">
        <OutbrainWidget />
      </div>} */}
      <div className="mt-4 md:mx-0 mx-4 hidden md:block">
        <React.Suspense><MoreStories newsType={newsType} currentNewsID={newsId} /></React.Suspense>
      </div>
    </div>
  );
};

export default NewsDetails;
